import { NgClass, NgIf, NgOptimizedImage } from '@angular/common';
import { Component, Input } from '@angular/core';
import { StoryblokDirective } from 'src/app/directive/storyblok.directive';

@Component({
    selector: 'app-feature',
    imports: [NgOptimizedImage, NgClass, NgIf, StoryblokDirective],
    templateUrl: './feature.component.html',
    styleUrl: './feature.component.scss'
})
export class FeatureComponent {
  @Input() image!: any;
  @Input() image_mobile!: any;
  @Input() _editable: any;
  @Input() _uid!: string;
  @Input() component!: string;
}
